import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {Button, Tooltip} from '@material-ui/core';

const styles = () => ({
  button: {
    margin: '20px',
  },
});
const AadLogin = (props) => {
  const {onLogin, classes} = props;

  return (
    <Tooltip title="Login">
      <Button
        className={classes.button}
        variant="contained"
        color="primary"
        onClick={onLogin}
      >
        Login With Office 365
      </Button>
    </Tooltip>
  );
};

AadLogin.propTypes = {
  onLogin: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AadLogin);
